'use client';

import { Toaster } from 'sonner';
import { useTheme } from 'next-themes';

/**
 * Mobile-aware toaster (Sonner; the legacy Radix toast was never mounted).
 * Bottom-positioned above the tab bar on phone via CSS offsets; standard
 * bottom-right on desktop.
 */
export function AppToast() {
  const { resolvedTheme } = useTheme();
  return (
    <Toaster
      position="bottom-center"
      offset={{
        bottom: 'calc(var(--mobile-tabbar-height) + 12px)'
      }}
      mobileOffset={{
        bottom: 'calc(var(--mobile-tabbar-height) + 12px)'
      }}
      toastOptions={{
        classNames: {
          toast: 'font-sans',
          error: '[&_[data-icon]]:text-destructive'
        },
        style: {
          background: 'var(--popover)',
          color: 'var(--popover-foreground)',
          border: 'none',
          borderRadius: 'var(--radius-xl)',
          boxShadow: 'var(--shadow-md)',
          padding: 'var(--component-card-padding)',
          fontSize: 'var(--text-meta)'
        }
      }}
      theme={resolvedTheme === 'light' ? 'light' : 'dark'}
      closeButton={false}
    />
  );
}
